import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { axiosInstance } from 'hooks/auth/AxiosInstance';
import { SmsTemplate } from 'utils/types';

type Options = {
  enabled?: boolean;
};

const fetchData = async (): Promise<SmsTemplate[]> => {
  try {
    const response: AxiosResponse<SmsTemplate[]> =
      await axiosInstance.get('sms-template');
    return response.data;
  } catch (error) {
    if (error instanceof Error) {
      throw new Error(error.message);
    } else {
      throw new Error('An unknown error occurred');
    }
  }
};

const useGetSmsTemplates = ({ enabled = true }: Options = {}): UseQueryResult<
  SmsTemplate[],
  Error
> => {
  return useQuery<SmsTemplate[], Error>({
    queryKey: ['sms-templates'],
    queryFn: fetchData,
    enabled,
    refetchOnWindowFocus: false,
    staleTime: 0,
  });
};

export default useGetSmsTemplates;
